module.exports = __webpack_public_path__ + "static/media/down.6e88458e.svg";